import { useState } from "react";
import { useAppDispatch, useAppSelector } from "../../../lib/redux/hooks";
import { createLegalRepresentative, updateLegalRepresentative, validateLegalRepresentativeCreateRequest } from "../../../pages/clienti/feature/legalRepresentative/slice";
import { getCustomerById } from "../../../pages/clienti/feature/slice";
import { colors } from "../../colors";
import { CloseIcon } from "../../icons/close";
import { CustomHorizontalTab } from "../../organisms/customHorizontalTab";
import { ButtonComponent } from "../button/newButton";
import { RappLegaleAnagrafica } from "./content/anagrafica";
import { RappLegaleContatti } from "./content/contatti";
import { RappLegaleDataIngUsc } from "./content/date";
import { RappLegaleNote } from "./content/note";
import { RappLegaleRecapiti } from "./content/recapiti";

interface Props {
  closeHandler: () => void;
  mode: "create" | "edit";
  idx?: number;
  visible?: boolean;
  customerId: string
}

const TABS = ['Anagrafica', 'Recapiti', 'Contatti', 'Data Ingresso/Uscita', 'Note']

export function RappLegalePopup(props: Props) {
  const { closeHandler } = props;
  const [selectedTab, setSelectedTab] = useState(0)
  const dispatch = useAppDispatch()
  const legalRapresentativeState = useAppSelector(state => state.legalRapresentative)

  const handleClose = () => {
    closeHandler()
  }

  const handleSave = async () => {
    if (props.mode === "create") {
      try {
        await dispatch(validateLegalRepresentativeCreateRequest({ ...legalRapresentativeState.legalRepresentativeCreateRequest, customerId: props.customerId })).unwrap()
        await dispatch(createLegalRepresentative({ ...legalRapresentativeState.legalRepresentativeCreateRequest, customerId: props.customerId })).unwrap()
        dispatch(getCustomerById(props.customerId))
        closeHandler()
      } catch {
      }
      return
    }

    const legalRepresentativeId = legalRapresentativeState.getLegalRepresentativeByIdResponse?.id
    if (!legalRepresentativeId) {
      return
    }

    try {
      await dispatch(updateLegalRepresentative({ id: legalRepresentativeId, data: legalRapresentativeState.legalRepresentativeUpdateRequest })).unwrap()
      dispatch(getCustomerById(props.customerId))
      closeHandler()
    } catch {
    }
  }

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center">
      <div
        className="absolute inset-0 bg-black/40 backdrop-blur-sm"
        onClick={handleClose}
      />
      <div
        className="relative z-10 flex flex-col bg-white rounded-2xl shadow-2xl overflow-hidden"
        style={{ width: '800px', maxWidth: '95vw', maxHeight: '90vh' }}
      >
        <div className="flex items-center justify-between px-6 py-4 bg-brandPrimary-600">
          <h2
            style={{ fontFamily: 'Manrope' }}
            className="text-white font-semibold text-base"
          >
            {props.mode === "edit"
              ? 'Modifica Rappresentante Legale'
              : 'Aggiungi Rappresentante Legale'}
          </h2>
          <button
            onClick={handleClose}
            className="text-white/70 hover:text-white transition-colors p-2 rounded-lg hover:bg-white/10"
          >
            <CloseIcon size={16} color={colors.white} />
          </button>
        </div>
        <CustomHorizontalTab
          selectedIndex={selectedTab}
          onTabClick={setSelectedTab}
        >
          {TABS.map(t => <div key={t}>{t}</div>)}
        </CustomHorizontalTab>
        <div className="flex-1 bg-neutral-50 px-6 py-5 overflow-y-auto">
          {selectedTab === 0 && <RappLegaleAnagrafica mode={props.mode} />}
          {selectedTab === 1 && <RappLegaleRecapiti mode={props.mode} />}
          {selectedTab === 2 && <RappLegaleContatti mode={props.mode} />}
          {selectedTab === 3 && <RappLegaleDataIngUsc mode={props.mode} />}
          {selectedTab === 4 && <RappLegaleNote mode={props.mode} />}
        </div>
        <div className="flex items-center justify-end gap-3 px-6 py-4 border-t border-neutral-200 bg-white">
          <ButtonComponent
            variant="outline"
            color="blue"
            label="Annulla"
            iconPosition="off"
            size="md"
            onClick={handleClose}
          />
          <ButtonComponent
            variant="solid"
            color="orange"
            label="Salva"
            iconPosition="off"
            size="md"
            onClick={handleSave}
          />
        </div>
      </div>
    </div>
  )
}

export default RappLegalePopup